<template>
  <section>
    redirecionando...
  </section>
</template>

<script>
import MatriculaService from '@/services/matricula.service.js'

export default {
  props: {
    action: {
      type: String
    },
    step: {
      type: String
    },
    idMatricula: {
      type: [String, Number]
    },
    uuid: {
      type: [String, Number]
    }
  },
  data () {
    return {
      uuidWait: false,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null
    }
  },
  mounted () {
    this.getMatriculaByUUID()
  },
  methods: {
    getMatriculaByUUID () {
      console.log('action...', this.action)
      console.log('idMatricula...', this.idMatricula)
      console.log('uuid...', this.uuid)

      MatriculaService.getMatriculaByUUID ( this.uuid ).then(
        response => {
          console.log('getMatriculaByUUID:', response.data)

          if ( Object.keys(response.data).length > 0  && response.data.email ) {
            this.$nextTick(() => {
              const go = {
                name: 'Nova Matrícula Autônoma', 
                // replace: true,
                params: {
                  action: 'nova',
                  step: 'unidade-curso', 
                  idMatricula: this.idMatricula,
                  // uuid: this.uuid
                },
                query: { 
                  token: process.env.VUE_APP_LARAVEL_API_LOGIN_TOKEN, 
                  email: response.data.email
                }
              }

              console.log("go:", go)
              this.$router.push(go)
            })
            
          } else {
            window.toaster.emit('open', { style: 'error', message: 'Erro ao carregar as informações da matrícula. Procure nosso time de atendimento.', floater: true })
          }
        }
      )
      .catch(error => {
        console.error(error)
        window.toaster.emit('open', { style: 'error', message: 'Erro ao carregar as informações da matrícula. Procure nosso time de atendimento.', floater: true })
      })
      .finally(() => {

      }) 
    },  
  }
}
</script>

<style>

</style>